export default __webpack_public_path__ + "static/media/Punto_07_Il_Pontino_SPA_Def.f7a562f5.aac";